import React, { useState } from "react";
import axios from "axios";

const Index: React.FC = () => {
  const [imageName, setImageName] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [error, setError] = useState("");

  const fetchImageUrl = async () => {
    if (!imageName.trim()) {
      setError("Ingrese un nombre de imagen válido.");
      return;
    }

    try {
      setError(""); // Limpiar errores previos
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/blob-url/${imageName}`
      );

      if (response.data.success) {
        setImageUrl(response.data.imageUrl);
      } else {
        setError("No se pudo obtener la URL de la imagen.");
      }
    } catch (err) {
      setError("Error al obtener la imagen. Verifique el nombre o el servidor.");
      console.error("Error al obtener la URL del blob:", err);
    }
  };

  return (
    <div className="p-4 border rounded shadow-md max-w-md mx-auto">
      <h2 className="text-lg font-bold mb-2">Obtener Imagen de Azure</h2>

      <input
        type="text"
        placeholder="Ingrese el nombre de la imagen"
        value={imageName}
        onChange={(e) => setImageName(e.target.value)}
        className="border p-2 w-full rounded mb-2"
      />

      <button
        onClick={fetchImageUrl}
        className="bg-blue-500 text-white px-4 py-2 rounded w-full"
      >
        Obtener Imagen
      </button>

      {error && <p className="text-red-500 mt-2">{error}</p>}

      {imageUrl && (
        <div className="mt-4">
          <p className="text-green-500 font-bold">Imagen obtenida:</p>
          <img src={imageUrl} alt="Blob Image" className="mt-2 w-full rounded shadow-lg" />
        </div>
      )}
    </div>
  );
};

export default Index;
